import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-naglowek-non-auth',
  templateUrl: './naglowek-non-auth.component.html'
})
export class NaglowekNonAuthComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
